import React, { useState } from 'react';
import './Login.css';

const ADMIN_USER = 'RDPM2123';
const ADMIN_PASSWORD = '26409253';
const TEMP_USER_STORAGE_KEY = 'sidunea_temp_user';

const getStoredTempUser = () => {
  try {
    const raw = localStorage.getItem(TEMP_USER_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed.usuario || !parsed.clave) {
      return null;
    }
    return {
      usuario: parsed.usuario,
      clave: parsed.clave,
      active: Boolean(parsed.active),
    };
  } catch {
    return null;
  }
};

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [showTempModal, setShowTempModal] = useState(false);
  const [adminUnlockPass, setAdminUnlockPass] = useState('');
  const [adminUnlocked, setAdminUnlocked] = useState(false);
  const [modalError, setModalError] = useState('');
  const [modalInfo, setModalInfo] = useState('');
  const [tempUser, setTempUser] = useState(() => getStoredTempUser());
  const [tempDraft, setTempDraft] = useState(() => getStoredTempUser() || { usuario: '', clave: '', active: true });

  const openTempModal = () => {
    setShowTempModal(true);
    setAdminUnlockPass('');
    setAdminUnlocked(false);
    setModalError('');
    setModalInfo('');
    setTempDraft(tempUser || { usuario: '', clave: '', active: true });
  };

  const closeTempModal = () => {
    setShowTempModal(false);
    setAdminUnlockPass('');
    setAdminUnlocked(false);
    setModalError('');
    setModalInfo('');
  };

  const persistTempUser = (newTempUser) => {
    setTempUser(newTempUser);
    localStorage.setItem(TEMP_USER_STORAGE_KEY, JSON.stringify(newTempUser));
  };

  const handleAdminUnlock = (e) => {
    e.preventDefault();
    if (adminUnlockPass === ADMIN_PASSWORD) {
      setAdminUnlocked(true);
      setModalError('');
      setModalInfo('');
      return;
    }
    setModalError('Clave de administrador incorrecta');
    setModalInfo('');
  };

  const handleSaveTempUser = (e) => {
    e.preventDefault();
    if (!tempDraft.usuario.trim() || !tempDraft.clave.trim()) {
      setModalError('Debe indicar usuario y clave para el usuario temporal');
      setModalInfo('');
      return;
    }

    const cleanedUser = {
      usuario: tempDraft.usuario.trim(),
      clave: tempDraft.clave.trim(),
      active: tempDraft.active,
    };

    persistTempUser(cleanedUser);
    setTempDraft(cleanedUser);
    setModalError('');
    setModalInfo('Usuario temporal guardado correctamente');
  };

  const handleToggleTempUser = () => {
    if (!tempUser) {
      setModalError('Primero debe crear el usuario temporal');
      setModalInfo('');
      return;
    }
    const updated = { ...tempUser, active: !tempUser.active };
    persistTempUser(updated);
    setTempDraft(updated);
    setModalError('');
    setModalInfo(updated.active ? 'Usuario temporal activado' : 'Usuario temporal desactivado');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isAdmin = usuario === ADMIN_USER && clave === ADMIN_PASSWORD;
    const isTempUser =
      Boolean(tempUser && tempUser.active) &&
      usuario === tempUser.usuario &&
      clave === tempUser.clave;

    if (isAdmin || isTempUser) {
      setError('');
      onLogin();
    } else {
      setError('Usuario o clave incorrectos');
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-bg"></div>
      <div className={`login-window${shake ? ' login-shake' : ''}`}>
        <div className="login-titlebar">
          <div className="login-titlebar-icon">🔒</div>
          <span>SIDUNEA World - Inicio de Sesión</span>
        </div>
        <div className="login-body">
          <div className="login-logo-section">
            <div className="login-logo">
              <div className="login-logo-icon">🌐</div>
              <div className="login-logo-text">
                <span className="login-logo-title">SIDUNEAWorld</span>
                <span className="login-logo-subtitle">Sistema Aduanero Automatizado</span>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="login-user">Usuario:</label>
              <input
                id="login-user"
                type="text"
                value={usuario}
                onChange={(e) => { setUsuario(e.target.value); setError(''); }}
                autoFocus
                autoComplete="off"
                placeholder="Ingrese su usuario"
              />
            </div>
            <div className="login-field">
              <label htmlFor="login-pass">Clave:</label>
              <input
                id="login-pass"
                type="password"
                value={clave}
                onChange={(e) => { setClave(e.target.value); setError(''); }}
                placeholder="Ingrese su clave"
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            <div className="login-buttons">
              <button type="submit" className="login-btn login-btn-ok">
                Aceptar
              </button>
              <button type="button" className="login-btn login-btn-cancel" onClick={() => { setUsuario(''); setClave(''); setError(''); }}>
                Limpiar
              </button>
            </div>
            <div className="login-temp-access">
              <button type="button" className="login-btn login-btn-secondary" onClick={openTempModal}>
                Usuario temporal...
              </button>
            </div>
          </form>
          <div className="login-footer">
            <span>© 2026 SIDUNEA World v4.0</span>
          </div>
        </div>
      </div>

      {showTempModal && (
        <div className="login-modal-overlay" role="dialog" aria-modal="true">
          <div className="login-modal-window">
            <div className="login-modal-title">Gestor de Usuario Temporal</div>

            {!adminUnlocked && (
              <form onSubmit={handleAdminUnlock} className="login-modal-form">
                <p className="login-modal-text">Ingrese la clave de administrador para continuar.</p>
                <div className="login-field">
                  <label htmlFor="admin-pass">Clave administrador:</label>
                  <input
                    id="admin-pass"
                    type="password"
                    value={adminUnlockPass}
                    onChange={(e) => {
                      setAdminUnlockPass(e.target.value);
                      setModalError('');
                      setModalInfo('');
                    }}
                    placeholder="Clave de administrador"
                    autoFocus
                  />
                </div>
                {modalError && <div className="login-error">{modalError}</div>}
                {modalInfo && <div className="login-info">{modalInfo}</div>}
                <div className="login-buttons">
                  <button type="submit" className="login-btn login-btn-ok">Continuar</button>
                  <button type="button" className="login-btn login-btn-cancel" onClick={closeTempModal}>Cerrar</button>
                </div>
              </form>
            )}

            {adminUnlocked && (
              <form onSubmit={handleSaveTempUser} className="login-modal-form">
                <p className="login-modal-text">Crear o editar usuario temporal.</p>
                <div className="login-field">
                  <label htmlFor="temp-user">Usuario temporal:</label>
                  <input
                    id="temp-user"
                    type="text"
                    value={tempDraft.usuario}
                    onChange={(e) => {
                      setTempDraft((prev) => ({ ...prev, usuario: e.target.value }));
                      setModalError('');
                      setModalInfo('');
                    }}
                    placeholder="Usuario temporal"
                    autoFocus
                    autoComplete="off"
                  />
                </div>
                <div className="login-field">
                  <label htmlFor="temp-pass">Clave temporal:</label>
                  <input
                    id="temp-pass"
                    type="password"
                    value={tempDraft.clave}
                    onChange={(e) => {
                      setTempDraft((prev) => ({ ...prev, clave: e.target.value }));
                      setModalError('');
                      setModalInfo('');
                    }}
                    placeholder="Clave temporal"
                  />
                </div>
                <label className="login-check-row">
                  <input
                    type="checkbox"
                    checked={tempDraft.active}
                    onChange={(e) => {
                      setTempDraft((prev) => ({ ...prev, active: e.target.checked }));
                      setModalError('');
                      setModalInfo('');
                    }}
                  />
                  <span>Usuario temporal activo</span>
                </label>

                {tempUser && (
                  <div className="login-temp-state">
                    Estado actual: {tempUser.active ? 'Activo' : 'Desactivado'}
                  </div>
                )}

                {modalError && <div className="login-error">{modalError}</div>}
                {modalInfo && <div className="login-info">{modalInfo}</div>}
                <div className="login-buttons">
                  <button type="submit" className="login-btn login-btn-ok">Guardar</button>
                  <button type="button" className="login-btn login-btn-secondary" onClick={handleToggleTempUser}>
                    {tempUser && tempUser.active ? 'Desactivar' : 'Activar'}
                  </button>
                  <button type="button" className="login-btn login-btn-cancel" onClick={closeTempModal}>Cerrar</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
